export const LINKEDIN_BASE_URL = "https://linkedin.com/in/";
export const X_BASE_URL = "https://x.com/";
export const ACCEPT_IMAGE_FILES = "image/jpg, image/jpeg, image/png";

// Wallet verification message — MUST match the backend VERIFICATION_MESSAGE constant
export const VERIFICATION_MESSAGE = "Please sign this message to connect to FunDeSci.";
export const MIN_PRICE_RANGE = 0;
export const MAX_PRICE_RANGE = 100;
export const UN_REGISTERED = "un-registered";
// URL regex for validation - removed 'g' flag to prevent issues with .test() 
// maintaining lastIndex state across multiple calls
export const URL_REGEX =
  /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/i;

export const orgKeys = ["fundername", "description", "location"];
export const applicantKeys = [
  "firstname",
  "lastname",
  "title_rank",
  "university_college",
  "biography",
  "accomplishment",
  "skills",
  "experiences",
  "nationality",
];

export const EDITOR_LIMITS = {
  description: 3000,
  biography: 3000,
  experiences: 10000,
  accomplishment: 8000,

  summary: 10000,
  beneficiaries: 8000,
  equipment: 8000,

  result: 30000,
};
